import { Injectable } from "@angular/core";

@Injectable()
export class SessionService{
    setUserId(uid)
    {
        localStorage.setItem('courierapp_user_id', uid);
    }
    setUserRole(role)
    {
        localStorage.setItem('courierapp_role', role);
    }
    setUserName(name)
    {
        localStorage.setItem('courierapp_username', name);
    }
    setUserBranch(branch)
    {
        localStorage.setItem('branch', branch);
    }
    setEmployeeId(eid)
    {
        localStorage.setItem('courierapp_employee_id', eid);
    }
    get getUserId()
    {
        return localStorage.getItem('courierapp_user_id');
    }
    get getUserRole()
    {
        return localStorage.getItem('courierapp_role');
    }
    get getUserName()
    {
        return localStorage.getItem('courierapp_username');
    }
    get getUserBranch()
    {
        return localStorage.getItem('branch');
    }
    get getEmployeeId()
    {
        return localStorage.getItem('courierapp_employee_id');
    }
    clear()
    {
        localStorage.clear();
    }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/sessions/session.service.ts